/*
 * @Author: etong
 * @Date: 2021-08-11 16:04:24
 * @LastEditTime: 2021-08-11 16:05:09
 * @LastEditors: your name
 * @Description:
 * @FilePath: \oak\src\components\JJuxCommonTable\index.js
 * Think first, Program later
 */
import Vue from 'vue'
import JJuxCommonTable from './JJuxCommonTable'

Vue.component('JJuxCommonTable', JJuxCommonTable)
